import React, { useState, useEffect, useRef } from 'react';
import ICONS from '../config/icon';
import CourseCard from './CourseCard';
import { useInsertName } from "./utils/helpers";

import { PaperBG, PaperGradientBG } from '../kits';

import CustomCourseRequestPr from './CustomCourseRequestPr';

function SectionC() {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const coursesSectionRef = useRef(null);
  const inputRef = useRef(null);
  const name = useInsertName();

  // Kurse vom Backend laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setCourses(data.data);
        } else {
          console.error('Ungültige Kursdaten.');
        }
      })
      .catch((err) => console.error('Fehler beim Laden:', err));
  }, []);

  // Suche ausführen
  const performSearch = (query) => {
    const regex = new RegExp(
      query
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '.*')
        .split(' ')
        .map(word => `(?=.*${word})`)
        .join(''),
      'i'
    );

    const results = courses.filter((course) => {
      const descriptionText = Array.isArray(course.description)
        ? course.description.join(' ')
        : course.description || '';

      return (
        regex.test(course.title) ||
        regex.test(descriptionText) ||
        regex.test(course.instructor) ||
        regex.test(course.category)
      );
    });

    setFilteredCourses(results);
    setIsSearching(true);
  };

  // Input-Änderung verarbeiten
  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    if (value.trim() === '') {
      setIsSearching(false);
      setFilteredCourses([]);
    } else {
      performSearch(value);
    }
  };

  const noResults = isSearching && filteredCourses.length === 0;
  const hasResults = isSearching && filteredCourses.length > 0;

  return (
    <>
      <PaperGradientBG variant="zen151515">
        <section className="py-12 md:py-20 font-mono">
          <div className="max-w-3xl mx-auto px-6">

            {/* Header */}
           

            {/* Terminal-Suche */}
            <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40">

              {/* Title Bar */}
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
                <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
                <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
                <span className="w-3 h-3 rounded-full bg-[#28c840]" />
                <span className="ml-3 text-xs text-[#AC8E66] select-none">search</span>
              </div>

              {/* Terminal Content */}
              <div className="px-4 sm:px-6 py-5 sm:py-6 bg-[#0F0F0F]">

                {/* Input-Zeile */}
                <div className="flex items-center gap-2">
                  <span className="text-[#AC8E66] text-sm sm:text-base shrink-0">$</span>
                  <span className="text-[#EFEBDC]/60 text-sm sm:text-base shrink-0">search</span>
                  <input
                    ref={inputRef}
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder='"React", "3D", "Web" ...'
                    className="flex-1 bg-transparent text-sm sm:text-base text-[#EFEBDC] placeholder-[#EFEBDC]/25 outline-none border-none ring-0 focus:outline-none focus:ring-0 focus:border-none caret-[#AC8E66] font-mono"
                  />
                </div>

                {/* Ergebnis-Zeilen */}
                {hasResults && (
                  <p className="text-sm text-green-400 mt-3">
                    <span className="text-green-400/70">&gt;</span> found {filteredCourses.length} {filteredCourses.length === 1 ? 'course' : 'courses'}...
                  </p>
                )}

                {noResults && (
                  <p className="text-sm text-orange-400 mt-3">
                    <span className="text-orange-400/70">&gt;</span> no matches for "{searchQuery}"
                  </p>
                )}
              </div>
            </div>
          </div>
        </section>
      </PaperGradientBG>

      {/* Suchergebnisse — CourseCards */}
      {hasResults && (
        <PaperBG>
          <section ref={coursesSectionRef} className="py-12 font-mono">
            <div className="container mx-auto px-6">
              <p className="text-xs text-center text-slate-600 mb-8">
                {filteredCourses.length} {filteredCourses.length === 1 ? 'Kurs' : 'Kurse'} gefunden, {name}.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {filteredCourses.map((course) => (
                  <CourseCard
                    key={course.id}
                    course={course}
                    icon={ICONS[course.icon] || ICONS.default}
                  />
                ))}
              </div>
            </div>
          </section>
        </PaperBG>
      )}

      {/* Keine Ergebnisse — Anfrage-Formular inline */}
      {noResults && (
        <PaperGradientBG variant="zen151515">
          <section className="py-12 font-mono">
            <div className="max-w-2xl mx-auto px-6">
              <p className="text-xs text-center text-[#EFEBDC]/30 mb-2">
                <span className="text-[#AC8E66]/50">&gt;&nbsp;</span>no matches: sag mir einfach, was du brauchst.
              </p>
              <CustomCourseRequestPr
                autoOpen
                initialStep="kategorie"
              />
            </div>
          </section>
        </PaperGradientBG>
      )}
    </>
  );
}

export default SectionC;
